import React from "react";
import Navbar from "./Components/Navbar";
import Hero from "./Components/Hero";
import Testimonials from "./Components/Testimonials";

const App = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <Testimonials />
    </>
  );
};

export default App;
